

/******************************************************
    Sliders
******************************************************/
import $ from 'jquery';
import slick from 'slick-carousel';
import IScroll from 'iscroll/build/iscroll.js';


// scoped variables
var myScroll;


export default function initSliders() {
	iScrollSliders__init();
	slickSliders__init();

	if ($(".StopTheSpreadCarousel").length) {
		$(".StopTheSpreadCarousel").slick({
			arrows: false,
			dots: false,			
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			autoplay: true
		});
	}
}


/******************************************************
    iScroll Sliders
******************************************************/
function iScrollSliders__init() {
	if ($(".navSlider .navSlider__wrapper").length) {
		var settings = {
			keyBindings: true,
			scrollbars: false,
			bounce: false,
			momentum: true,
			scrollX: true,
			scrollY: false,
			freeScroll: true,
			zoom: false,
			click: true
		};
		myScroll = new IScroll('.navSlider .navSlider__wrapper', settings);
	}
}



/******************************************************
    Slick Sliders
******************************************************/
function slickSliders__init() {
	if ($(".cardList__slider").length) {
		setupCardList();
	}
	if ($(".homeCarousel").length) {
		setupHomeCarousel();
	}
}

/******************************************************
    Card List Slider
******************************************************/
function setupCardList() {
	if (Foundation.MediaQuery.atLeast('medium')) {
		initCardListSlider();
	}

	$(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
		if (oldSize === "small") {
			initCardListSlider();
		}

		if (newSize === "small") {
			destroyCardListSlider();
		}
	});
}

function setupHomeCarousel() {
	$(".homeCarousel").slick({
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 1000,
		arrows: false,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: false	
		
	});
}
function initCardListSlider() {
	$(".cardList__slider").slick({
		arrows: false,
		dots: true,
		slidesToShow: 2,
		slidesToScroll: 2,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}

function destroyCardListSlider() {
	$('.cardList__slider').slick('unslick');
}